export const getSelectedDepartment = (item) => {
  return  {
    type: "SELECTED_DEPARTMENT",
    payload: item
  };
};

export const fetchDepartment = (item) => {
  return  {
    type: "FETCH_DEPARTMENT",
    payload: item
  };
};
